export const OVERCOAT_DISPLAY_OPTIONS = {
  measurements: true,
  points: true,
  seamWalk: false,
};
